import React from 'react';
import { motion } from 'framer-motion';

const ClientLogos = () => {
  // Logos fictifs représentant les secteurs clients
  const clients = [
    { name: 'PME Nord', sector: 'Commerce' },
    { name: 'Artisan Pro', sector: 'Artisanat' },
    { name: 'Nord Digital', sector: 'Services' },
    { name: 'Bio & Co', sector: 'E-commerce' },
    { name: 'Lille Conseil', sector: 'Consulting' },
    { name: 'Tech Valley', sector: 'Tech' },
  ];

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 border-b border-[var(--border-glass)] bg-[rgba(255,255,255,0.01)]">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <p className="text-gray-500 uppercase tracking-[0.3em] text-xs font-semibold">
            Ils nous font confiance
          </p>
        </motion.div>

        {/* Logos Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
          {clients.map((client, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group flex flex-col items-center justify-center p-4 rounded-xl hover:bg-white/5 transition-all duration-300"
            >
              {/* Logo placeholder - cercle avec initiales */}
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[var(--primary)]/20 to-[var(--secondary)]/20 flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300 border border-white/10">
                <span className="text-xl font-bold text-white/70 group-hover:text-white transition-colors">
                  {client.name.split(' ').map(w => w[0]).join('')}
                </span>
              </div>
              <span className="text-gray-400 text-xs uppercase tracking-wider group-hover:text-white transition-colors">
                {client.sector}
              </span>
            </motion.div>
          ))}
        </div>

        {/* Trust Indicators */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
          className="mt-12 flex flex-wrap justify-center gap-8 md:gap-12"
        >
          {[
            { icon: '🛡️', text: '100% Satisfaction Garantie' },
            { icon: '⚡', text: 'Réponse sous 24h' },
            { icon: '🎯', text: 'Devis Gratuit' },
          ].map((item, index) => (
            <div key={index} className="flex items-center gap-3 text-gray-400">
              <span className="text-2xl">{item.icon}</span>
              <span className="text-sm font-medium">{item.text}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ClientLogos;
